import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { AppleIcon } from '../../../../assets/svg/register-social/AppleIcon';
import { GoogleIcon } from '../../../../assets/svg/register-social/GoogleIcon';
import { intl } from '../../../../helpers/IntGlobalProvider';
import Button from '../../../../react-components/Button';
import { Text } from '../../../../react-components/Text';
import { SocialLoginProviders } from '../../context/reducer';

interface SocialLoginButtonProps {
  socialAccount: SocialLoginProviders;
  onClick: (provider: SocialLoginProviders) => void;
}

export const SocialLoginButton = ({ socialAccount, onClick }: SocialLoginButtonProps) => {
  const SocialIcon = () => {
    switch (socialAccount) {
      case `google`:
        return <GoogleIcon />;
      case `apple`:
        return <AppleIcon />;
      default:
        return null;
    }
  };

  return (
    <Button
      onClick={() => onClick(socialAccount)}
      style={{
        backgroundColor: RoutalPalette.neutral02n,
        border: `1px solid ${RoutalPalette.secondary20n}`,
        borderRadius: `4px`,
        margin: `0px`,
        height: `30px`,
      }}
    >
      <Grid style={{ display: `flex`, alignItems: `center`, gap: `10px` }}>
        <SocialIcon />
        <Text
          style={{
            color: RoutalPalette.secondary80,
            fontSize: `14px`,

            fontWeight: 600,
            fontStyle: `normal`,
            lineHeight: `normal`,
          }}
        >
          {intl.formatMessage({ id: `drivers.login.${socialAccount}` })}
        </Text>
      </Grid>
    </Button>
  );
};
